export type Comment = {
  id: string
  name: string
  initials: string
  avatarColor: string
  body: string
  time: string
  likes: number
}

export const comments: Comment[] = [
  {
    id: 'paola',
    name: 'Paola G.',
    initials: 'PG',
    avatarColor: '#b45309',
    body:
      'Llevo 4 días aplicando el orden 1-2-3 y es increíble. Por primera vez en meses no tuve que atacar el chocolate a las 4 de la tarde. Gracias por la info.',
    time: '12 min',
    likes: 47,
  },
  {
    id: 'claudia',
    name: 'Claudia Méndez',
    initials: 'CM',
    avatarColor: '#1d4ed8',
    body:
      '¿Alguien más ha probado el truco del vinagre que mencionan? Me daba miedo el sabor pero mezclado con agua antes de la cena me ha quitado la pesadez de la mañana siguiente. ¡Muy recomendado!',
    time: '1 hora',
    likes: 112,
  },
  {
    id: 'lucia',
    name: 'Lucía R.',
    initials: 'LR',
    avatarColor: '#7e22ce',
    body:
      'Pensé que era otra dieta de pasar hambre, pero es pura lógica. Mi energía en el trabajo ha cambiado totalmente. Lo mejor es que pude comer pizza el viernes siguiendo el protocolo y no me inflamé.',
    time: '3 horas',
    likes: 89,
  },
]
